// @flow
import { type Node, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { find, propSatisfies, complement, is, map } from 'ramda';

import { api } from 'app/api';
import { GET_CAFETERIA_CUSTOMER_ORDERS_SALES, convertParams, convertResult } from 'app/common/api/requests/cafeteria/customer/orders/sales.get';

import changeFoodErrorProcessing from './changeFoodErrorProcessing';


type Props = {
  children: ({
    header: string,
    successMessage: string,
    requestOrderInitialItems: () => Promise<Array<{ id: string, amount: number }> | null>,
    errorProcessing: (Error) => string,
  }) => Node,
  whom: string,
  customerId: string,
  orderId: string,
}

const ChangeFood = ({ children, whom, customerId, orderId }: Props): Node => {
  const { t } = useTranslation('cafeteria');

  const header = t('order_request_sales_change_food_header', { whom });
  const successMessage = t('order_request_sales_change_food_success_message', { whom });

  const errorProcessing = useMemo(() => (
    changeFoodErrorProcessing(whom)
  ), [whom]);

  const requestOrderInitialItems = useCallback(async () => {
    const res = await api.request(GET_CAFETERIA_CUSTOMER_ORDERS_SALES, {
      error: t(
        'order_request_sales_change_fetch_error',
        'Не удалось получить данные заявки для редактирования',
      ),
      params: {
        customerId,
        orderId,
      },
      convertions: {
        convertParams,
        convertResult,
      },
    });

    if (res && !find(propSatisfies(complement(is(Number)), 'amount'), res)) {
      return map(({ id, amount }) => ({ id, amount: amount || 0 }), res);
    }
    return null;
  }, [customerId, orderId, t]);

  return (
    children({
      header,
      successMessage,
      requestOrderInitialItems,
      errorProcessing,
    })
  );
};

export default ChangeFood;
